import styled from "styled-components";

import { SPACING } from "../../../utils/constants";
import { StatusNote } from "../styles";

export const CatalogColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md}px;
  min-width: 0;
`;

export const DetailPane = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.sm}px;
  min-width: 0;

  &:focus {
    outline: none;
  }
`;

export const DetailActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${SPACING.sm}px;
`;

export const HiddenRowNotice = styled(StatusNote)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${SPACING.sm}px;
`;
